import { ErrorResponse, ErrorResponseDjango } from "~/types/global-types"

export const getErrorMessage = (
  error: ErrorResponse | ErrorResponseDjango | undefined
) => {
  if (typeof error?.details_v2 === "object" && error?.details_v2?.length) {
    if ("message" in error?.details_v2[0]) {
      return error?.details_v2[0].message
    }
  }
  if (typeof error?.details === "string") {
    const errorMessage = error.details.split("'")[1]
    return errorMessage
  }
  if (typeof error?.details === "object") {
    if ("title" in error.details) {
      return error.details.title[0]
    }
  }
  return "Une erreur est survenue"
}
